// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.gap_root_Ol88N {
  display: flex;
  flex-flow: column;
  margin-left: var(--left-width);
}
`, "",{"version":3,"sources":["webpack://./src/components/routeDiagram/gap.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,iBAAiB;EACjB,8BAA8B;AAChC","sourcesContent":[".root {\n  display: flex;\n  flex-flow: column;\n  margin-left: var(--left-width);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `gap_root_Ol88N`
};
module.exports = ___CSS_LOADER_EXPORT___;
